export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "3": "3",
        "4": "4",
        "5": "5",
        "8": "8",
        "10": "10",
        "12": "12",
        "16": "16",
        "20": "20",
        "24": "24",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "To add team members, you must first save form.",
        "Aby dodawać stanowiska musisz najpierw zapisać formularz.": "To add positions, you must first save form.",
        "Aby dodawać wydziały musisz najpierw zapisać formularz.": "To add departments, you must first save form.",
        "Akceptuj": "Accept",
        "Aktualizacja": "Update",
        "anuluj": "cancel",
        "Anuluj": "Cancel",
        "Automatyczna publikacja ogłoszeń": "Automatic publication of announcements",
        "Baza ogłoszeń": "Announcement database",
        "Baza PDF": "PDF database",
        "Brak stron": "No pages",
        "Cena": "Price",
        "Czekające na akceptację": "Waiting for approval",
        "Członkowie zespołu": "Team members",
        "Data do": "Date to",
        "Data dodania": "Date added",
        "Data modyfikacji": "Modification date",
        "Data od": "Date from",
        "Data ogłoszenia do": "Announcement date to",
        "Data ogłoszenia od": "Announcement date from",
        "Data opuszczenia zespołu": "Team leave date",
        "Data publikacji": "Publication date",
        "Data rozpoczęcia": "Start date",
        "Data zakończenia": "End date",
        "Daty publikacji zostały zaktualizowane.": "Publication dates have been updated.",
        "Dodaj": "Add",
        "Dodaj do zespołu": "Add to team",
        "Dodaj kategorię": "Add category",
        "Dodaj ofertę": "Add offer",
        "Dodaj ogłoszenie": "Add announcement",
        "Dodaj PDF": "Add PDF",
        "Dodaj rodzaj ogłoszenia": "Add announcement type",
        "Dodaj stronę": "Add page",
        "Dodaj tylko pracowników z wybranych wydziałów": "Add only employees from selected departments",
        "Dodaj zasób": "Add resource",
        "Dodane przez": "Added by",
        "Dodane przeze mnie": "Added by me",
        "Dodanie kategorii": "Adding category",
        "Dodanie oferty": "Adding offer",
        "Dodanie ogłoszenia": "Adding announcement",
        "Dodanie PDF": "Adding PDF",
        "Dodanie rodzaju": "Adding type",
        "Dodanie zasobu": "Adding resource",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "Document is not published anywhere yet.",
        "Dokument nie ma ustawionej daty publikacji.": "Document does not have publication date set.",
        "Edycja kategorii": "Edit category",
        "Edycja oferty": "Edit offer",
        "Edycja ogłoszenia": "Edit announcement",
        "Edycja PDF": "Edit PDF",
        "Edycja rodzaju": "Edit type",
        "Edycja zasobu": "Edit resource",
        "Edytuj": "Edit",
        "Edytuj członka grupy": "Edit group member",
        "Erecruiter": "Erecruiter",
        "Firma": "Company",
        "Galeria zdjęć": "Photo gallery",
        "Generowanie stron gazetek...": "Generating newsletter pages...",
        "Generuj strony gazetki": "Generate newsletter pages",
        "Id": "Id",
        "ID": "ID",
        "Ilość ogłoszeń w kategorii": "Number of announcements in category",
        "Ilość zasobów w kategorii": "Number of resources in category",
        "Imię": "First name",
        "Imię i Nazwisko": "First and Last Name",
        "Inspekcja": "Inspection",
        "Język": "Language",
        "Kategoria": "Category",
        "Kategoria została dodana.": "Category has been added.",
        "Kategoria została usunięta.": "Category has been deleted.",
        "Kategoria została zaktualizowana.": "Category has been updated.",
        "Kategorie ogłoszeń": "Announcement categories",
        "Kategorie zasobów": "Resource categories",
        "Konta użytkowników": "User accounts",
        "Liczba wyników na stronie": "Number of results per page",
        "Liczba wyświetlanych dokumentów": "Number of displayed documents",
        "Liczba wyświetlanych galerii": "Number of displayed galleries",
        "Liczba wyświetlanych najnowszych elementów": "Number of displayed latest items",
        "Liczba wyświetlanych nowych pracowników": "Number of displayed new employees",
        "Liczba wyświetlanych ogłoszeń": "Number of displayed announcements",
        "Link do aplikowania": "Application link",
        "Link do oferty": "Offer link",
        "Link do strony": "Page link",
        "Lista jest pusta": "List is empty",
        "Lista rezerwacji": "Reservation list",
        "Login": "Login",
        "Miasto": "City",
        "Moduły": "Modules",
        "Multimedia": "Multimedia",
        "Nazwa": "Name",
        "Nazwa kategorii": "Category name",
        "Nazwa stanowiska": "Position name",
        "Nazwa użytkownika": "Username",
        "Nazwa zespołu": "Team name",
        "Nazwisko": "Last name",
        "Nie": "No",
        "Nie można zaakceptować wybranej rezerwacji. Wybrany termin jest już zajęty.": "Cannot accept selected reservation. Selected time slot is already occupied.",
        "Nie udało się pobrać listy kategorii": "Failed to retrieve category list",
        "Nie udało się pobrać listy rezerwacji": "Failed to retrieve reservation list",
        "Nie udało się pobrać listy rodzajów": "Failed to retrieve type list",
        "Nie udało się pobrać listy ról": "Failed to retrieve role list",
        "Nie udało się pobrać listy stanowisk": "Failed to retrieve position list",
        "Nie udało się pobrać listy wydziałów": "Failed to retrieve department list",
        "Nie udało się pobrać listy zasobów": "Failed to retrieve resource list",
        "Nie zdefiniowano żadnych ról.": "No roles have been defined.",
        "Nie znaleziono żadnych użytkowników.": "No users found.",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Nowy dokument": "New document",
        "Numer referencyjny": "Reference number",
        "Odrzucone": "Rejected",
        "Odrzuć": "Reject",
        "Oferta została dodana.": "Offer has been added.",
        "Oferta została usunięta.": "Offer has been deleted.",
        "Oferta została zaktualizowana.": "Offer has been updated.",
        "Oferty pracy - Import": "Job offers - Import",
        "Ogłoszenia": "Announcements",
        "Ogłoszenie": "Announcement",
        "Ogłoszenie nie jest jeszcze nigdzie opublikowane.": "Announcement is not published anywhere yet.",
        "Ogłoszenie nie ma ustawionej daty publikacji.": "Announcement does not have publication date set.",
        "Ogłoszenie zostało dodane.": "Announcement has been added.",
        "Ogłoszenie zostało usunięte.": "Announcement has been deleted.",
        "Ogłoszenie zostało zaktualizowane.": "Announcement has been updated.",
        "Opiekun": "Supervisor",
        "Opis": "Description",
        "Opis zespołu": "Team description",
        "Opublikuj": "Publish",
        "PDF": "PDF",
        "PDF nie jest jeszcze nigdzie opublikowany.": "PDF is not published anywhere yet.",
        "PDF nie ma ustawionej daty publikacji.": "PDF does not have publication date set.",
        "PDF został dodany.": "PDF has been added.",
        "PDF został usunięty.": "PDF has been deleted.",
        "PDF został zaktualizowany.": "PDF has been updated.",
        "Plik PDF": "PDF file",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "After selecting this option, individual privileges and privileges inherited from roles are not taken into account.",
        "Pochodzenie": "Origin",
        "Pole \"Email\" jest wymagane.": "Field \"Email\" is required.",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "Field \"Username\" is required.",
        "Pole nie może zawierać spacji": "Field cannot contain spaces",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdź akceptację": "Confirm approval",
        "Powiązane stanowiska": "Related positions",
        "Powiązane wydziały": "Related departments",
        "Powód odrzucenia rezerwacji": "Reason for reservation rejection",
        "Powrót": "Back",
        "Publikacja": "Publication",
        "Publikacja ogłoszeń przez użytkownika": "Publication of announcements by user",
        "Publikacja została dodana.": "Publication has been added.",
        "Publikacja została usunięta.": "Publication has been deleted.",
        "Publikuj do": "Publish to",
        "Publikuj od": "Publish from",
        "Regulaminy": "Regulations",
        "Rezerwacja zasobów": "Resource reservation",
        "Rezerwacja została odrzucona.": "Reservation has been rejected.",
        "Rezerwacja została usunięta.": "Reservation has been deleted.",
        "Rezerwacja została zaakceptowana.": "Reservation has been accepted.",
        "Rodzaj": "Type",
        "Rodzaj ogłoszenia": "Announcement type",
        "Rodzaj ogłoszenia został dodany.": "Announcement type has been added.",
        "Rodzaj ogłoszenia został usunięty.": "Announcement type has been deleted.",
        "Rodzaj ogłoszenia został zaktualizowany.": "Announcement type has been updated.",
        "Rodzaje ogłoszeń": "Announcement types",
        "Role użytkownika": "User roles",
        "Role zespołu": "Team roles",
        "Stanowiska": "Positions",
        "Stanowisko": "Position",
        "Stanowisko zostało dodane.": "Position has been added.",
        "Stanowisko zostało usunięte.": "Position has been deleted.",
        "Status": "Status",
        "Status oferty został zmieniony.": "Offer status has been changed.",
        "Status ogłoszenia został zmieniony.": "Announcement status has been changed.",
        "Status PDF został zmieniony.": "PDF status has been changed.",
        "Strona": "Page",
        "Strona z modułu baza dokumentów": "Page from document database module",
        "Strony gazetki": "Newsletter pages",
        "Studio": "Studio",
        "System": "System",
        "Tagi": "Tags",
        "Tak": "Yes",
        "Ten zespół nie posiada jeszcze żadnych powiązanych stanowisk": "This team does not have any related positions yet",
        "Ten zespół nie posiada jeszcze żadnych powiązanych wydziałów": "This team does not have any related departments yet",
        "Tokeny": "Tokens",
        "Uprawnienia": "Privileges",
        "Ustawienia": "Settings",
        "Ustawienia konta": "Account settings",
        "Ustawienia ogłoszeń": "Announcement settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usuń": "Delete",
        "Usuń z zespołu": "Remove from team",
        "Użytkownik jest liderem zespołu": "User is team leader",
        "Użytkownik posiada pełne uprawnienia": "User has full privileges",
        "Użytkownik został dodany do zespołu.": "User has been added to team.",
        "Użytkownik został dodany.": "User has been added.",
        "Użytkownik został zaktualizowany.": "User has been updated.",
        "W zespole od %0": "In team since %0",
        "W zespole od %0 do %1": "In team from %0 to %1",
        "Wersje": "Versions",
        "Właściwości": "Properties",
        "Województwo": "Province",
        "Wpis został zaktualizowany.": "Entry has been updated.",
        "Wszyscy użytkownicy": "All users",
        "Wszystkie": "All",
        "Wszystkie języki": "All languages",
        "Wybierz": "Select",
        "Wybierz autora": "Select author",
        "Wybierz opiekuna": "Select supervisor",
        "Wybierz stanowisko": "Select position",
        "Wybierz stronę": "Select page",
        "Wybierz strony": "Select pages",
        "Wybierz użytkownika": "Select user",
        "Wybierz wydział": "Select department",
        "Wybór języka": "Language selection",
        "Wybór listy stron": "Page list selection",
        "Wybór listy stron artykułów": "Article page list selection",
        "Wybór listy stron galerii": "Gallery page list selection",
        "Wybór listy stron ogłoszeń": "Announcement page list selection",
        "Wybór strony": "Page selection",
        "Wybrane": "Selected",
        "Wybranie strony jest wymagane": "Selecting page is required",
        "Wydział": "Department",
        "Wydział został dodany.": "Department has been added.",
        "Wydział został usunięty.": "Department has been deleted.",
        "Wydziały": "Departments",
        "Wymagaj wszystkich warunków": "Require all conditions",
        "Wymagana akceptacja": "Approval required",
        "zacznij pisać aby wyszukać autora...": "start typing to search for author...",
        "zacznij pisać aby wyszukać opiekuna...": "start typing to search for supervisor...",
        "zacznij pisać aby wyszukać stanowisko...": "start typing to search for position...",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search for user...",
        "zacznij pisać aby wyszukać wydział...": "start typing to search for department...",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and go back",
        "Zarezerwował": "Reserved by",
        "Zarezerwowane": "Reserved",
        "Zasoby": "Resources",
        "Zasób": "Resource",
        "Zasób aktywny": "Active resource",
        "Zasób nie jest jeszcze nigdzie opublikowany.": "Resource is not published anywhere yet.",
        "Zasób został dodany.": "Resource has been added.",
        "Zasób został usunięty.": "Resource has been deleted.",
        "Zasób został zaktualizowany.": "Resource has been updated.",
        "Zdjęcie główne": "Main image",
        "Zespoły": "Teams",
        "Zespół aktywny": "Active team",
        "Zespół został dodany.": "Team has been added.",
        "Zespół został usunięty.": "Team has been deleted.",
        "Zespół został zaktualizowany.": "Team has been updated.",
        "Zmień daty publikacji": "Change publication dates",
        "Zmień widok": "Change view",
        "Zobacz wszystkie ogłoszenia": "View all announcements",
        "Zobacz wszystkie rezerwacje": "View all reservations"
    }
};
